import PropTypes from 'prop-types';

/**
 * @param {Array.<JSX.Element>} children
 * @param {string} className
 * @param {boolean} collapse - Whether to add "`flex-direction: column`" on mobile.
 * @returns {JSX.Element}
 * @constructor
 */
export default function Row({ children, className, collapse = true }) {
    return (
        <div
            className={`esc-ii-flex ${collapse ? 'esc-ii-flex-col ' : ''}lg:esc-ii-flex-row${
                className ? ' ' + className : ''
            }`}
        >
            {children}
        </div>
    );
}

Row.propTypes = {
    className: PropTypes.string,
    collapse: PropTypes.bool,
};
